import { BasicButtonInverted } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { ShowCardUser } from 'components/showCard/showCardUser'
import { useShowsUser } from 'hooks/user/useShows'
import { useNavigate } from 'react-router-dom'
import { ShowWithImages } from 'types/Show'

import { ButtonContainer, CardContainer, Container, Title } from './shows.style'

export const LandingShows = () => {
    const { data, isLoading, error } = useShowsUser()
    const navigate = useNavigate()

    const handleClick = () => {
        navigate(`/musor/`)
    }

    const getRandomShows = (shows: ShowWithImages[], count: number) => {
        const shuffled = [...shows].sort(() => 0.5 - Math.random())
        return shuffled.slice(0, count)
    }

    return (
        <Container>
            <Title>Legjobb előadásaink</Title>
            <LoadingContainer isLoading={isLoading} error={error}>
                {data && data.length > 0 ? (
                    <CardContainer>
                        {getRandomShows(data, 4).map((show) => (
                            <ShowCardUser
                                key={show.show_id}
                                show_id={show.show_id}
                                image={show.cover_image}
                                title={show.name}
                                description={show.description}
                            />
                        ))}
                    </CardContainer>
                ) : (
                    <PlaceholderContainer>
                        <p>Hamarosan új előadások érkeznek!</p>
                    </PlaceholderContainer>
                )}
                <ButtonContainer>
                    <BasicButtonInverted onClick={handleClick}>További előadásaink</BasicButtonInverted>
                </ButtonContainer>
            </LoadingContainer>
        </Container>
    )
}
